import React from 'react';
import { Link } from 'react-router-dom';

function TournamentListElement({ date, tournamentType, id, association, golfCourse, location, tournamentName, onClick }) {
  return (
    // <Link
    //   to={`/tournaments/detail?${id}`}
    //   className="tournament-list-element-link"
    //   style={{ textDecoration: 'none' }}
    // >
      <div className="tournament-list-element" onClick={onClick}>
        <div className="tournament-list-element-date">{date}</div>
        <div className="tournament-list-element-details">
          <div className="tournament-list-element-name">{tournamentName}</div>
          <div className="tournament-list-element-info">
            <span className="tournament-list-element-label">Location:</span>
            {location}
          </div>
          <div className="tournament-list-element-info">
            <span className="tournament-list-element-label">Type:</span>
            {tournamentType}
          </div>
          <div className="tournament-list-element-info">
            <span className="tournament-list-element-label">Association:</span>
            {association}
          </div>
          {golfCourse && (
            <div className="tournament-list-element-info">
              <span className="tournament-list-element-label">Course:</span>
              {golfCourse}
            </div>
          )}
        </div>
      </div>
    // </Link>
  );
}

export default TournamentListElement;